import { Button, SxProps, Theme, Tooltip, Typography } from "@mui/material";
import React from "react";

interface IconTextButtonProps {
  Icon?: React.ReactNode;
  ariaLabel?: string;
  label?: string;
  onClick: () => void;
  variant?: "text" | "outlined" | "contained";
  sx?: React.CSSProperties | SxProps<Theme>;
  tooltip?: string;
  disabled?: boolean;
  textColor?: string;
}

function IconTextButton({
  Icon,
  label,
  onClick,
  variant = "outlined",
  ariaLabel,
  sx,
  tooltip,
  disabled,
  textColor
}: IconTextButtonProps) {
  return (
    <Tooltip title={tooltip}>
      <Button
        aria-label={ariaLabel}
        variant={variant}
        startIcon={Icon ?? undefined}
        sx={{
          border: "1px solid #D5D7DA",
          borderRadius: "8px",
          height: "40px",
          padding: "8px 16px",
          textTransform: "none",
          color: "#717680",
          bgcolor: "white",
          "&:hover": {
            bgcolor: "#f5f5f5",
            border: "1px solid #D5D7DA",
          },
          ...sx,
        }}
        onClick={onClick}
        disabled={disabled}
      >
        {label && (
          <Typography
            sx={{
              fontWeight: 600,
              fontFamily: "Inter",
              fontSize: "14px",
              lineHeight: 1.2,
              color: textColor || "#717680",
            }}
          >
            {label}
          </Typography>
        )}
      </Button>
    </Tooltip>
  );
}

export default IconTextButton;
